import { render, staticRenderFns } from "./deptPower copy.vue?vue&type=template&id=585f5278&scoped=true&"
import script from "./deptPower copy.vue?vue&type=script&lang=js&"
export * from "./deptPower copy.vue?vue&type=script&lang=js&"
import style0 from "./deptPower copy.vue?vue&type=style&index=0&id=585f5278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f5278",
  null
  
)

export default component.exports